<template>
  <SwitchGroup as="div" class="flex justify-between gap-3" :class="reverse && 'flex-row-reverse'">
    <span class="flex flex-grow flex-col">
      <SwitchLabel
        as="span"
        class="font-medium"
        :class="{ 'text-xs': small, 'text-sm': !small, 'text-neutral-80': disabled, 'text-neutral-0': !disabled }"
        passive
        ><slot name="label">{{ label }}</slot></SwitchLabel
      >
      <SwitchDescription
        as="span"
        :class="{ 'text-xs': small, 'text-sm': !small, 'text-neutral-90': disabled, 'text-neutral-70': disabled }"
        ><slot name="description">{{ description }}</slot></SwitchDescription
      >
      <slot name="other"></slot>
    </span>
    <div>
      <Switch
        :model-value="modelValue"
        :small="small"
        :disabled="disabled"
        :loading="loading"
        class="mt-2"
        :class="reverse && 'm-0 mr-4'"
        @update:modelValue="!disabled && $emit('update:modelValue', $event)"
      />
    </div>
  </SwitchGroup>
</template>

<script lang="ts" setup>
//Components
import Switch from "@atoms/SwitchButton.vue";
import { SwitchGroup, SwitchLabel, SwitchDescription } from "@headlessui/vue";

//Props
withDefaults(
  defineProps<{
    small?: boolean;
    disabled?: boolean;
    modelValue?: boolean;
    label?: string;
    description?: string;
    loading?: boolean;
    reverse?: boolean;
  }>(),
  {
    small: false,
    disabled: false,
    modelValue: false,
    label: undefined,
    description: undefined,
    loading: false,
    reverse: false,
  },
);

//Emits
defineEmits<{
  (e: "update:modelValue", modelValue: boolean): void;
}>();
</script>
